/**
 * @module stringTemplateParser
 */

/**
 * Parse template variables used in some product configuration fields.
 * The template variables look like Javascript template literals, 
 * (i.e. ${variable}) but they are not processed that way.
 * 
 * @param {string} expression - The string containing template variables
 * @param {object} valueObj - key/value pairs for replacing template variables
 * @returns {string} The expression string with template variables replaced
 */
export function stringTemplateParser(expression, valueObj) {
  const templateMatcher = /\${\s?([^{}\s]*)\s?}/g;
  let text = expression.replace(templateMatcher, (substring, value, index) => {
    value = valueObj[value];
    return value;
  });
  return text;
}
